import React, { useCallback } from "react";
import ReusableTable from "./ReusableTable";
import { fetchAllZoomAccounts } from "../util/fetchUserUtil"; // Import the fetchSubscribers function

export const ZoomTable = () => {
  const fetchData = useCallback(async (postData) => {
    try {
      return await fetchAllZoomAccounts();
    } catch (error) {
      const errorMessage =
        error?.response?.data?.data?.errorMessage ||
        error.message ||
        "An unknown error occurred";
      throw new Error(errorMessage);
    }
  }, []);

  const actionButtonsMeta = [
    {
      name: "New Account",
      action: "createZoomAccount",
    },
  ];

  return (
    <div className="flex flex-col ">
      <ReusableTable
        key={"zoom_accounts"}
        tableType={"zoom_accounts"}
        tableName={"Zoom Accounts"}
        needGlobalFilter={false}
        needPagination={false}
        onStateChange={fetchData}
        actionButtonsMeta={actionButtonsMeta}
      />
    </div>
  );
};

export default ZoomTable;
